// Sidebar.jsx - Responsive navigation component for admin panel
import React from 'react';
import { BookOpen, Users, TrendingUp, X, Menu } from 'lucide-react';

const Sidebar = ({ currentView, onViewChange, isOpen, onClose }) => {
  const navigationItems = [
    { 
      id: 'modules', 
      label: 'Módulos y Contenido', 
      icon: BookOpen,
      description: 'Gestión de cursos'
    },
    { 
      id: 'users', 
      label: 'Gestión de Usuarios', 
      icon: Users,
      description: 'Administrar estudiantes'
    },
    { 
      id: 'progress', 
      label: 'Seguimiento de Progreso', 
      icon: TrendingUp,
      description: 'Avance de estudiantes'
    }
  ];

  const handleNavClick = (itemId) => {
    onViewChange(itemId);
    if (onClose) onClose(); // Close sidebar on mobile after selection
  };

  return (
    <>
      {/* Mobile Overlay */}
      {isOpen && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-50 z-40 lg:hidden"
          onClick={onClose}
        />
      )}

      {/* Sidebar */}
      <div className={`
        fixed lg:static inset-y-0 left-0 z-50
        w-64 bg-gray-900 text-white h-screen p-6 flex flex-col
        transform transition-transform duration-300 ease-in-out
        ${isOpen ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'}
      `}>
        {/* Header */}
        <div className="flex items-center justify-between mb-8">
          <div className="flex items-center space-x-3">
            <div className="w-10 h-10 bg-blue-600 rounded-lg flex items-center justify-center">
              <BookOpen className="w-6 h-6" />
            </div>
            <div>
              <h1 className="text-lg font-bold">Admin Panel</h1>
              <p className="text-xs text-gray-400">Universidad de Asesores</p>
            </div>
          </div>
          
          {/* Close button - Mobile only */}
          <button
            onClick={onClose}
            className="lg:hidden text-gray-400 hover:text-white"
          >
            <X className="w-6 h-6" />
          </button>
        </div>
        
        {/* Navigation */}
        <nav className="space-y-2 flex-1">
          {navigationItems.map(item => (
            <button
              key={item.id}
              onClick={() => handleNavClick(item.id)}
              className={`w-full flex items-center space-x-3 px-4 py-3 rounded-lg transition-all duration-200 group ${
                currentView === item.id 
                  ? 'bg-blue-600 text-white shadow-lg' 
                  : 'text-gray-300 hover:bg-gray-800 hover:text-white'
              }`}
            >
              <item.icon className={`w-5 h-5 flex-shrink-0 ${
                currentView === item.id ? 'text-white' : 'text-gray-400 group-hover:text-white'
              }`} />
              <div className="flex-1 text-left">
                <div className={`text-sm font-medium ${
                  currentView === item.id ? 'text-white' : 'text-gray-300'
                }`}>
                  {item.label}
                </div>
                <div className={`text-xs ${
                  currentView === item.id ? 'text-blue-100' : 'text-gray-500 group-hover:text-gray-400'
                }`}>
                  {item.description}
                </div>
              </div>
            </button>
          ))}
        </nav>

        {/* Footer */}
        <div className="border-t border-gray-700 pt-4 mt-4">
          <div className="text-xs text-gray-500">
            <p>Versión 2.1.4</p>
            <p className="mt-1">© 2025 Universidad de Asesores</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default Sidebar;